export interface UnifiedBookingFlowLaunchDarklyFlags {
  readonly diagnosisOfframp?: boolean
  readonly bookingFaCallOptional?: boolean
  readonly selfServeFlow?: selfServeFlowVariants
}

export enum selfServeFlowVariants {
  On = 'on',
  Off = 'off',
  HalfSplit = 'halfSplit'
}

export enum AbTestSplit {
  Control = 'control',
  Test = 'test'
}
